import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@components-library/Tooltip';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import styles from './fieldLabel.module.scss';

interface ILabelField {
  label: string;
  htmlFor?: string;
  required?: boolean;
  tooltip?: string | ReactNode;
}

export const FieldLabel = ({ label, htmlFor, required, tooltip }: ILabelField) => {
  const { i18n } = useTranslation();

  return (
    <label className={styles.fieldLabel} htmlFor={htmlFor}>
      {i18n.t(label as KeyMapKeys)}
      {required && <span className={styles.required}>*</span>}
      {tooltip && <Tooltip className={styles.fieldLabelTooltip} content={tooltip} />}
    </label>
  );
};
